<template>
  <transition-group
    name="newsletter-subscribe__wrapper-fade"
    tag="div"
    class="newsletter-subscribe__wrapper"
  >
    <div
      v-show="currentStep == 1"
      key="1"
      @click.prevent="goToStep(2)"
      class="newsletter-subscribe__inner newsletter-subscribe__inner--teaser"
    >
      <div class="newsletter-subscribe__headline">{{ $t('title') }}</div>
      <div class="newsletter-subscribe__content newsletter-subscribe__content--indented">
        {{ $t('prompt') }}
      </div>
      <div class="newsletter-subscribe__cta">
        <span class="newsletter-subscribe__cta-link">{{ $t('sign_up') }}</span>
      </div>
    </div>

    <div
      v-show="currentStep == 2"
      key="2"
      class="newsletter-subscribe__inner newsletter-subscribe__inner--form"
      :class="{
        'newsletter-subscribe__inner--error': requestState == REQUEST_STATES.error,
        'newsletter-subscribe__inner--disabled': !ctaButtonsActive,
      }"
    >
      <div class="newsletter-subscribe__headline">{{ $t('title') }}</div>
      <div class="newsletter-subscribe__content">
        <input
          ref="email"
          v-model="email"
          class="newsletter-subscribe__input"
          type="email"
          :placeholder="$t('global.email_address')"
          @keyup="handleEmailInputChange"
        />
      </div>
      <div
        v-if="requestState == REQUEST_STATES.error"
        class="newsletter-subscribe__content newsletter-subscribe__content--indented"
      >
        {{ $t('error') }}
      </div>
      <div v-else class="newsletter-subscribe__cta">
        <FormSelect
          id="gender"
          value=""
          :options="genderOptions"
          @update:value="updateSelectedGender($event)"
        />
        <span
          class="cta cta--button cta--blue"
          @click.prevent="
            submitNewsletterSignupForm({ gender: selectedGender, source: SOURCES.footer })
          "
          >{{ $t('subscribe') }}</span
        >
      </div>
    </div>

    <div
      v-show="currentStep == 3"
      key="3"
      class="newsletter-subscribe__inner newsletter-subscribe__inner--success"
    >
      <div class="newsletter-subscribe__headline">{{ $t('title') }}</div>
      <div class="newsletter-subscribe__content newsletter-subscribe__content--indented">
        {{ $t('success') }}
      </div>
    </div>
  </transition-group>
</template>

<script>
import newsletterSignupFormMixin, { SOURCES } from '@/mixins/newsletter-signup-form'
import FormSelect from '@/components/_shared/Form/Select/FormSelect.vue'

export default {
  name: 'NewsletterSignup',

  components: {
    FormSelect,
  },

  mixins: [newsletterSignupFormMixin],

  data() {
    return {
      ctaButtonsActive: false,
      currentStep: 1,
      onSuccess: () => this.goToStep(3),
      selectedGender: '',
      SOURCES,
    }
  },

  methods: {
    goToStep(step) {
      this.currentStep = step
      this.$nextTick(() => this.$refs.email.focus())
    },

    handleEmailInputChange() {
      this.ctaButtonsActive = On.helpers.validateEmail(this.email)
    },

    updateSelectedGender(value) {
      this.selectedGender = value
    },
  },
}
</script>

<i18n src="@/locales/newsletter_signup.json"></i18n>